import { Box, Typography, Avatar, Stack } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { mergeTheme } from '../types';
import type { ThemeCustomization } from '../types';

interface EventOrganizerProps {
  name?: string;
  email?: string;
  phone?: string;
  logo?: string;
  showEmail?: boolean;
  showPhone?: boolean;
  themeCustomization?: ThemeCustomization;
}

export function EventOrganizer({ name, email, phone, logo, showEmail = true, showPhone = true, themeCustomization }: EventOrganizerProps) {
  const mergedTheme = mergeTheme(themeCustomization);
  const textColor = mergedTheme.colors?.textColor || '#222222';
  const textSecondaryColor = mergedTheme.colors?.textSecondaryColor || '#666';
  const primaryColor = mergedTheme.colors?.primaryColor || '#64B5F6';
  if (!name) return null;

  return (
    <Box sx={{ mt: 3, fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif' }}>
      <Typography
        variant="subtitle1"
        fontWeight={600}
        gutterBottom
        sx={{
          fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif',
          color: textColor, // Texto principal (título)
        }}
      >
        Organizador
      </Typography>
      <Stack direction="row" alignItems="flex-start" spacing={2}>
       
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{
              fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif',
              color: textColor, // Texto principal
              mb: 1,
            }}
          >
            {name}
          </Typography>
          {email && showEmail && (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
              <EmailIcon
                sx={{
                  color: primaryColor,
                  fontSize: '1.2rem'
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: textSecondaryColor, // Texto secundário
                  fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif',
                }}
              >
                {email}
              </Typography>
            </Stack>
          )}
          {phone && showPhone && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <PhoneIcon
                sx={{
                  color: primaryColor,
                  fontSize: '1.2rem'
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: textSecondaryColor, // Texto secundário
                  fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif',
                }}
              >
                {phone}
              </Typography>
            </Stack>
          )}
        </Box>
      </Stack>
    </Box>
  );
}

